import { Model } from "@vuex-orm/core";
import shortid from "shortid"
import Contact from "./Contact";
import ContactAddress from "./ContactAddress";
import ContactPhone from "./ContactPhone";
import _ from 'lodash'

export default class RequestContact extends Model {
    static entity = 'requestContacts'
    static fields() {
        return {
            id: this.attr("tmp/" + shortid.generate()),
            contactId: this.attr(null),
            contact: this.belongsTo(Contact, 'contactId'),
            contactAddressId: this.attr(null),
            contactAddress: this.belongsTo(ContactAddress, 'contactAddressId'),
            contactPhoneId: this.attr(null),
            contactPhone: this.belongsTo(ContactPhone, 'contactPhoneId'),
            dateUpdated: this.attr(null),
            dateRemoved: this.attr(null),
            dateCreated: this.attr(null),
            status: this.attr('active')
        }
    }

    deleteAllInRequestContact() {
        const vm = this

        // only remove if only one dependency was found (the one being deleted)
        if(vm.contact && vm.contact.contactRequestContacts && vm.contact.contactRequestContacts.length === 1) {
            vm.$delete({ where: vm.id })
            if(_.has(vm, 'contact'))
                vm.contact.deleteAllInContact()
            return true
        }
        return false
    }

}